import { type RouteLocation, type RouteRecordRaw } from 'vue-router';

import { ROUTE_DATA } from '@/constants/routes.constants';
import { routerHelper } from '@/services/router-helper';

const AgreementOverview = (): unknown => {
    return import(/* webpackPrefetch: true */ '@/pages/agreement-overview/agreement-overview-page.vue');
};

export const agreementOverviewRoute: RouteRecordRaw = {
    ...ROUTE_DATA.AGREEMENT_OVERVIEW_PAGE,
    components: {
        main: AgreementOverview
    },
    props: {
        main(route: RouteLocation): { agreementId?: number } {
            return { agreementId: routerHelper.parseParamToInt(route.params.id as string) };
        }
    }
};
